export const convertStringToNum = (str: string): number | null => {
  if (str === null || str === '' || str === undefined || typeof str === 'boolean') {
    return null;
  } else {
    const num = +str;

    return isNaN(num) ? null : num;
  }
}
